<template>
    <div class="o-m-searchbar m-searchbar">
        <OMobileSeacrHeader
            v-if="!isLandscape"
            title="Search"
            subtitle="Search all stores, restaurants and services"
        />
        <div class="m-searchbar__header">
            <AMBackButton
                v-if="isLandscape"
                theme="back"
                text=""
                class="o-m-searchbar__back-btn"
                @onClick="handleClickBack"
            />
            <MSearchbar
                v-model="value"
                icon="right"
                :is-setting-icon="!isLandscape && true && false"
                :autofocus="true"
            />
            <span 
                v-if="isLandscape"
                class="o-m-searchbar__search-text"
            >
                SEARCH
            </span>
        </div>
        <div class="m-searchbar__container">
            <OMainCategoryMenu
                v-if="!searchValue"
                @onMenuClick="handleMenuClick"
            />
            <OSearchresult
                v-else
                :items="getItems"
                :hasStrictResult="hasStrictResult"
                @onSearchTileClick="handleSearchTileClick"
            />
        </div>
        <!-- <div class="m-searchbar__footer">
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';

import MSearchbar from '../../molecules/m-searchbar/m-searchbar';
import AMBackButton from '../../atoms/a-m-back-button/a-m-back-button';
import OSearchresult from '../../organisms/o-searchresult/o-searchresult';
import OMainCategoryMenu from '../../organisms/o-main-category-menu/o-main-category-menu';
import OMobileSeacrHeader from '../../organisms/o-mobile-search-header/o-mobile-search-header';

import {SUCCESS_SEARCH} from '../../../utils/constants/bus-events-constants'

import search from '../../../utils/mixins/search';

export default {
    name: 'OMSearchbar',
    components: {
        MSearchbar,
        AMBackButton,
        OSearchresult,
        OMainCategoryMenu,
        OMobileSeacrHeader
    },
    mixins: [search],
    data() {
        return {
            expansionMergedData: true
        }
    },
    computed: {
        ...mapState({
            isLandscape: state => state.landscape
        })
    },
    methods: {
        handleMenuClick(data) {
            const params = {
                name: `mobile.${data}`
            };
            this.$router.push(params);
        },
        handleSearchTileClick(data) {
            this.$bus.$emit(SUCCESS_SEARCH, {
                value1: this.value,
                value2: "found",
                value3: "request_guide",
                target: 'object',
                target_type: data.type,
                target_id: data.id,
            })
            const isTenant = data.type === 'tenant';
            const isServiceCategory = data?.serviceCategory || false;
            const isCategory = data?.type === 'category' || data?.type === 'brand';
            const type = isCategory ? 'search.category'
                : isTenant || !isServiceCategory ? 'guide' : 'service';
            const paramsPropsName = isCategory ? 'categoryId' : 'type';
            const paramsPropsData = isCategory ? data.id : 'search';

            const params = {
                name: `mobile.${type}`,
                params: {
                    [paramsPropsName]: paramsPropsData
                },
                query: {}
            };
            
            params.query = isCategory ? ''
                : isTenant || !isServiceCategory ? { to: data.id } : { id: data.id };

            this.$router.push(params);
        },
        handleClickBack() {
            const params = {
                name: `mobile.${this.$route.params.from}`
            };
            this.$router.push(params);
        }
    }
}
</script>

<style lang="scss">
@import "o-m-searchbar";
</style>
